import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorStateMatcher } from '@angular/material/core';
import { debugInterceptor, R1ErrorMatcher } from '@r1-compass-library/utilities';
import { compassHttpInterceptor } from './interceptor/compass-http.interceptor';
import { jsonUtilPageSettings } from '@r1-compass-library/utilities/json-util-page-setting-interceptor';
import { mocksInterceptor } from '@r1-compass-library/utilities/mocks.interceptor';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(routes),
        provideAnimations(),
        provideHttpClient(
            withInterceptorsFromDi(),
            withInterceptors([
                debugInterceptor,
                // loggingInterceptor
                compassHttpInterceptor,
                jsonUtilPageSettings,
                mocksInterceptor,
            ])
        ),
        { provide: ErrorStateMatcher, useClass: R1ErrorMatcher },
    ],
};
